import React from "react"
import styled from "styled-components"
import { Text, Flex, Grid, LinkButton, InactiveLinkButton } from "src/styled"

import { devices } from "src/theme/device"

export const Modal = styled(Flex)`
    display: none;
    top: 100%;
    z-index: 3;
    right: 0px;
    padding: 20px;
    position: absolute;
    background: white;
    text-align: center;
    flex-direction: column;
    min-width: 200px;
`

export const BasketOrderItem = styled(Grid)`
    padding: 5px;
    grid-column-gap: 30px;
    grid-auto-flow: column;
    border-bottom: 1px solid #cccccc;
    width: 350px;
    ${devices.laptop} {
        width: 250px;
    }
`

// Prices, the total and an active "ZAMAWIAM" are shown only once the basket
// has been reconciled with the current menu (pricesVerified) and the last menu
// check did not fail (menuError), SUSHI-435.
export default ({
    items,
    totalPrice,
    pricesVerified = false,
    menuError = false,
    setBasketDisplay,
}) => (
    <Modal shadowed id="basket">
        {items.length === 0 ? (
            <Text> Nie masz produktów w koszyku. </Text>
        ) : (
            <>
                <Text color={"secondary"}> Moje zamówienie </Text>
                {pricesVerified && !menuError && (
                    <Text fontSize={24} mb={20}>
                        {totalPrice} zł
                    </Text>
                )}
                {!pricesVerified && !menuError && (
                    <Text mb={20}>Sprawdzamy aktualne ceny…</Text>
                )}
                {menuError && (
                    <Text color={"danger"} mb={20}>
                        Nie udało się pobrać aktualnego menu. Odśwież stronę.
                    </Text>
                )}
                {items.map((item, index) => (
                    <BasketOrderItem key={index}>
                        <Text textAlign={"left"}> x{item.quantity} szt </Text>
                        <Text textAlign={"center"}> {item.name} </Text>
                        <Text textAlign={"right"}>
                            {pricesVerified && !menuError && (
                                <> {item.price * item.quantity} zł </>
                            )}
                        </Text>
                    </BasketOrderItem>
                ))}
                <Flex>
                    {pricesVerified && !menuError ? (
                        <LinkButton
                            width={1}
                            variant={"primary"}
                            to={"/basket"}
                        >
                            ZAMAWIAM
                        </LinkButton>
                    ) : (
                        <InactiveLinkButton width={1} variant={"primary"}>
                            ZAMAWIAM
                        </InactiveLinkButton>
                    )}
                </Flex>
            </>
        )}
    </Modal>
)
